
export type EventName = 'add_payment_info' | 'qualify_lead' | 'add_shipping_info' | 'refund' | 'add_to_cart' | 'remove_from_cart' | 'add_to_wishlist' | 'search' | 'begin_checkout' | 'select_content' | 'close_convert_lead' | 'select_item' | 'close_unconvert_lead' | 'select_promotion' | 'disqualify_lead' | 'share' | 'earn_virtual_currency' | 'sign_up' | 'event' | 'spend_virtual_currency' | 'generate_lead' | 'tutorial_begin' | 'item' | 'tutorial_complete' | 'join_group' | 'unlock_achievement' | 'level_end' | 'view_cart' | 'level_start' | 'view_item_list' | 'level_up' | 'view_item' | 'login' | 'view_promotion' | 'post_score' | 'working_lead' | 'purchase' | string;

export interface GtagParameters {
    [key:string]:JSONValue|undefined|GtagParameters[];
}
export interface GtagEvent extends GtagParameters{
    send_to?: 'default' | string;
}
/**
 * https://developers.google.com/tag-platform/gtagjs/reference/parameters?hl=ja
 */
export const event = <T extends GtagEvent>(eventName:EventName,parameters?:T) => new Promise<['event',string,T|undefined]>( (resolve) => {
    window.gtag('event',eventName,{
        event_callback: () => resolve(['event',eventName,parameters]),
        event_timeout: 2000,
        ...parameters        
    });
});
